const ALL_API_ROUTES = {
    "outbound_email_preview": "/team_stats/outbound_email_preview",
    "team_member_unsubscribe": "/outbound_mail/unsubscribe",
    "export_teams_stats": "/team_stats/export_teams_stats",
    "team_subscriber_data": "/team_stats/team_subscriber_data",
    "team_stats": "/team_stats",
    "team_stats_update": "/team_stats/update",
    "non_outbound_stats": "/team_stats/daily_team_stats",
    "team_members_stats": "/team_members_stats",
    "regular_email_preview": "team_stats/regular_email_preview",
    "rss_candidate_sources": "/rss_candidates/:id/rss_sources",
    "get_rss_candidate": "rss_candidates/:id",
    "get_rss_candidate_selectors": "/rss_candidates/find_url",
    "post_update_selectors": "/rss_candidates/update_selectors",
    "get_rss_candidate_preview": "/rss_candidates/find_content",
    "get_rss_candidate_external_preview": "/rss_candidates/fetch_external_url",
    "export_rss_candidates": "/rss_candidates/export_rss_candidates",
    "fetch_article_source": "/search/fetch_article_source",
    "flag_post": "/post/:post_id/flag",
    "flag_matching_article": "/aggregate/:article_id/flag",
    "get_post": "/post/:id",
    "get_feed": "/feed",
    "get_clubbed_posts": "/posts/clubbed_posts",
    "bulk_updates_companies": "/companies/bulk_update",
    "bulk_import_team_members": "/team/bulk_invite_team_members",
    "archive_prospect": "/prospects/:prospect_id/archive",
    "unmap_prospect": "/prospects/:prospect_id/unmap",
    "email_trigger_status": "/email_configuration",
    "create_or_update_email_type": "/email_configuration/create_or_update_email_type",
    "get_linkedin_prospects": "/prospects/ln_prospects",
    "add_rss_candidate": "/rss_candidates/create_or_update",
    "get_directory": "/linkedin_prospect/lists/directory",
    "sync_linkedin_prospects_to_crm": "/linkedin_prospect/sync_to_crm",
    "get_data_mine_list_show": "/linkedin_prospect/list/:list_id",
    "get_data_mine_prospects_contacts": "/linkedin_prospect/fetch_contacts",
    "create_or_update_custom_fields": "/team/custom_fields",
    "add_fields_newsfeed_export": "/team/add_fields_newsfeed_export",
    "delete_custom_field": "/team/delete_custom_field",
    "download_marketing_pdf_data": "/linkedin_prospect/export_linkedin_list_pdf_data",
    "create_linkedin_list": "/linkedin_prospect/lists",
    "generate_mapping_suggestions": "/linkedin_prospect_suggestion/generate_suggestions",
    "event_record": "/record_response",
    "get_keyword_search_articles": "search/articles",
    "track_amplitude_event": "/amplitude/track_event",
    "lead_data_record": "/record_response",
    "get_search_spaces": "/search_spaces",
    "get_single_search_space": "/search_spaces/:id",
    "suggest_team_members": "suggestions/team_members",
    "delete_tag": "/team/tags/delete_tag",
    "get_save_or_remove_post": "/post/:id/save_or_remove_post",
    "get_saved_posts": "/prospects/:id/saved_posts",
    "create_prospects_from_list": "/linkedin_prospect/list/:id/create_prospects_from_list",
    "get_rss_experiments": "/rss_experiments",
    "get_crm_matched_relationships": "/blackbaud/get_matched_relations",
    "post_crm_matched_relationships": "/blackbaud/create_update_relations",
    "temp_mapper_generate_suggestions": "/temp_mapper/generate_suggestions",
    "temp_mapper_map": "/temp_mapper/map",
    "temp_mapper_preview_map": "/temp_mapper/preview_map",
    "update_linkedin_list": "/linkedin_prospect/lists/update_list",
    "fetch_linkedin_lists": "/linkedin_prospect/fetch_team_lists",
    "create_ln_sync_urls": "/linkedin_prospects/create_linkedin_sync_urls",
    "get_temp_job_updates": "/temp_post",
    "map_and_post_job": "/temp_post/map",
    "export_mapper_posts": "/temp_post/export_mapper_posts",
    "get_directory_aggregates": "/linkedin_prospects/fetch_all_aggregates",
    "pipe_drive_app_init": "/pipe_drive_app_init",
    "create_relation": "/blackbaud/create_relation",
    "merge_prospects": "/prospects/merge_prospects",
    "edit_past_education": "/prospects/edit_past_education",
    "remove_past_education": "/prospects/delete_past_education",
    "temp_mapper_index": "/temp_mapper",
    "temp_mapper_filter_options": "/temp_mapper/filter_options",
    "temp_mapper_accept_clear_winners": "/temp_mapper/accept_clear_winners",
    "temp_mapper_dismiss": "/temp_mapper/dismiss",
    "temp_mapper_export": "/temp_mapper/export",
    "temp_mapper_summary": "/temp_mapper/summary",
    "temp_mapper_delete_suggestions": "/temp_mapper/delete_suggestions",
    "post_review_update": "/post/:post_id/review_update",
    "get_prospect_tracking_settings": "/prospects/:id/tracking_settings",
    "update_prospect_tracking_settings": "/prospects/:id/update_tracking_settings",
    "toggle_news_query": "/prospects/:id/toggle_news_query",
    "get_data_exports": "/data_exports",
    "get_feed_aggregates": "/posts/aggregates",
    "get_article_aggregates": "/article_filters",
    "get_prospect_aggregates": "/prospect_aggregates",
    "send_otp_verification": "/users/otp_verify",
    "post_resend_otp": "/users/resend_otp",
    "get_report": "/reports/:id",
    "create_ai_report": "/reports/create_ai_report",
    "update_report": "/reports/:id/update",
    "delete_report": "/reports/:id/delete",
    "get_all_reports": "/reports",
    "logout": "/users/logout",
    "team_update": "/team/team_update",
    "get_team_info": "/team/team_details",
    "create_message": "/reports/create_message",
    "report_conversations": "/reports/:id/conversations",
    "report_duplicate_config": "/reports/:id/duplicate_config",
    "get_team_members": "/team_members",
    "team_members_export": "/team_members/export",
    "create_post": "/posts",
    "aggregate_publish": "/aggregate/:id/publish",
    "update_post": "/post/:id/update_description",
    "get_possible_email": "/linkedin_prospect/fetch_possible_email",
    "bulk_fetch_possible_email": "/linkedin_prospect/list/fetch_possible_emails",
    "get_dir_sugg_url": "/linkedin_prospects/new_term_search",
    "scalekit_authenticate": "/auth/sso-auth",
    "scalekit_initialize_auth": "/auth/initiate-authentication",
    "get_new_directory": "/linkedin_prospect/lists/new_directory",
    "get_flagged_directory": "/linkedin_prospect/lists/flagged_directory",
    "get_flagged_count": "/linkedin_prospect/flagged_count",
    "bulk_flag_prospects": "/linkedin_prospect/bulk_flag",
    "bulk_unflag_prospects": "/linkedin_prospect/bulk_unflag",
    "export_flagged_directory": "/linkedin_prospect/export_flagged_directory",
    "create_custom_report": "/reports/create_custom_report",
    "get_datamine_list_export": "/linkedin_prospect/new_export_linkedin_list",
    "custom_report_export": "/reports/custom_report_export",
    "ai_report_export": "/reports/:id/export",
    "temp_mapper_retry_status": "/temp_mapper/retry_status",
    "windfall_profile": "/windfall/profile",
    "daily_publishing_summary": "/daily_publishing/summary",
    "daily_publishing_teams": "/daily_publishing/teams",
    "daily_publishing_team_detail": "/daily_publishing/team_detail",
    "daily_publishing_chart": "/daily_publishing/chart",
    "daily_publishing_mentioned_for": "/daily_publishing/mentioned_for",
}
const getApiUrl = (key, options = null) => {
    if (!key || !ALL_API_ROUTES[key]) {
        throw new TypeError(`No api routes for the ${key} provided`);
    }
    let url = ALL_API_ROUTES[key]
    if (options) {
        Object.keys(options).forEach((k) => {
            url = url.replace(k, options[k]);
        })
    }
    return url
}

export const apiStub = (response_data) => {
    return new Promise(resolve => setTimeout(() => resolve(response_data), 1000))
}

export default getApiUrl
